<div
  class="page-wrapper"
  *ngIf="!isLoading"
  [ngClass]="{
    'collapsed-app-content': sidebarCollapsed,
    'expanded-app-content': !sidebarCollapsed
  }"
>
  <div class="home-section">
    <header class="home-header"></header>
  </div>

  <div class="home-section">
    <div class="home-summary-tool-section">
      <summary-card></summary-card>
      <tools-card></tools-card>
    </div>

    <div class="home-feedback-section">
      <feedback-card (openRequested)="onFeedbackOpenRequested($event)"> </feedback-card>
      <confirmation-modal
        [open]="showModal"
        [title]="'Redirecting to email'"
        [message]="
          'You are about to be redirected outside of Clinical Decision Suite. Your default email client will provide an email address where you can send your feedback.\n\n\nDo you want to continue?'
        "
        confirmLabel="Continue"
        cancelLabel="Cancel"
        (closed)="onModalClosed($event)"
      >
      </confirmation-modal>
      <provider-modal
        [open]="showProviderModal"
        [title]="'Select email provider'"
        (selected)="onProviderSelected($event)"
      >
      </provider-modal>
    </div>
  </div>
</div>
